import styled from 'styled-components';

export const DisclaimerBar = styled.div`
  background: rgba(0, 0, 0, 0.4);
  color: rgba(255, 255, 255, 0.65);
  font-size: 0.72rem;
  line-height: 1.35;
  text-align: center;
  padding: 6px 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  letter-spacing: 0.1px;

  @media (max-width: 600px) {
    font-size: 0.68rem;
    padding: 5px 10px;
  }
`;
